import { Input, OnInit, ViewChild } from '@angular/core'
import { Component } from '@angular/core'
import { SortDescription } from '@grapecity/wijmo'
import { Grid } from '../../utility/grid'
import { WjGridGrouppanelModule } from '@grapecity/wijmo.angular2.grid.grouppanel'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

@Component({
    selector: 'grid-column-group',
    templateUrl: './grid-column-group.component.html',
    standalone: true,
    imports: [WjGridGrouppanelModule, WjInputModule],
})
export class GridColumnGroupComponent {
    @ViewChild('panel') panel: any
    @ViewChild('menu') menu: any
    @Input() grid!: Grid<any>
    groupIndex = -1

    contextMenu(e: any) {
        let groupDescription = this.panel.hitTest(e),
            cv = this.panel.collectionView
        if (groupDescription) {
            this.groupIndex = cv.groupDescriptions.indexOf(groupDescription)
            this.menu.show(e)
        }
        e.preventDefault()
    }
    // handle context menu commands
    itemClicked(menu: any) {
        let grid = this.grid,
            cv = grid.view as any,
            groupIndex = this.groupIndex
        switch (menu.selectedIndex) {
            case 0: // expand all
                grid.flexGrid.collapseGroupsToLevel(groupIndex + 1)
                break
            case 1: // collapse all
                grid.flexGrid.collapseGroupsToLevel(groupIndex)
                break

            case 3: // sort asc
            case 4: // sort desc
            case 5: // no sort
                cv.deferUpdate(() => {
                    cv.sortDescriptions.clear()
                    if (menu.selectedIndex != 5) {
                        let binding = cv.groupDescriptions[groupIndex].propertyName
                        cv.sortDescriptions.push(new SortDescription(binding, menu.selectedIndex == 3))
                    }
                })
                break
        }
    }
}
